import React from 'react';
import './Footer.css';

import { Logo, Newsletter } from '../../components'; // Importing the Logo and Newsletter components
import { contactContent, services } from '../../constants'; // Importing contact information and services data

// Importing necessary icons from react-icons
import { FaFacebookF, FaInstagram, FaLinkedin, FaCar } from 'react-icons/fa';
import { FaXTwitter } from "react-icons/fa6";

// Importing Link for navigation
import { Link } from 'react-router-dom'; 



const Footer = () => {

  return (
    <footer className='footer'>

      <div className='box-container'>

        {/* About Section */}
        <div className='footer-item'>

          <Logo /> {/* Display the Logo component */}
          <p>Offering the best deals on new and pre-owned cars. Your trusted partner for quality vehicles.</p> {/* Description for the about section */}

          {/* Newsletter component to subscribe */}
          <Newsletter variant='dark' idPrefix='2' />

        </div>

        {/* Services Links Section */}
        <div className='footer-item'> 

          <h2>Our Services</h2>

          <div className='info links'> 
            {/* Mapping through the services and creating links to each service page */}
            {services.map(service => {
              /* Link to the individual service page */
              return <p key={service.id}><FaCar className='icon' /> 
                <Link
                  to={{ 
                    pathname: '/Services/' + service.title, // Dynamically constructing the link path
                  }}
                  location={{service}} // Passing service data to the route
                  state={service} // Passing service data in state
                >
                  {service.title}  {/* Display Service Title */}
                </Link>
              </p>
            })}
          </div>
        </div>

        {/* Useful Links Section */}
        <div className='footer-item'> 

          <h2>Quick Links</h2>

          {/* Links for easy navigation to various pages */}
          <div className='info links'> 
            <p><FaCar className='icon' /><Link to='/about-us'>about</Link></p>
            <p><FaCar className='icon' /><Link to='/Services'>Services</Link></p>
            <p><FaCar className='icon' /><Link to='/Car-Grid'>Cars</Link></p>
            <p><FaCar className='icon' /><Link to='/Dealers'>Dealers</Link></p>
            <p><FaCar className='icon' /><Link to='/Shop-list'>shop</Link></p>
            <p><FaCar className='icon' /><Link to='/Contact-us'>contact</Link></p>
          </div>

        </div>

        {/* Contact Info Section */}
        <div className='footer-item'>

        <h2>Contact Info</h2>

        <div className='info connect'>

          {contactContent
          .filter(contact => contact.id !== 4) // Exclude the contact with id: 4
          .map((contact) => (
              contact.content.map((value, index) => (
                <div key={index} className='connect-item'>
                  <div className='icon'>{contact.icon}</div>
                  <span>{value}</span>
                </div>
              ))
          ))}
        </div>

      </div>



      </div>

      <div className='content'>

        {/* Footer content with copyright information */}
        <p>&copy; Primecars 2024 All Rights Reserved</p>

        {/* Social media icons with links */}
        <div className='social'>
          <a href="/#"><FaFacebookF className='icon' /></a>
          <a href="/#"><FaXTwitter className='icon' /></a>
          <a href="/#"><FaInstagram className='icon' /></a>
          <a href="/#"><FaLinkedin className='icon' /></a>
        </div>

      </div>

    </footer>
  )
}

export default Footer;